//
export const RELOAD_IFRAME = '@@affectli/legacy/RELOAD_IFRAME';

export const reloadIframe = () => dispatch => {
    dispatch({ type: RELOAD_IFRAME });
};
